/* eslint-disable import/no-internal-modules */
import { Component } from 'preact'
import { BulkActionComponentProps } from '@insided/deprecated-control/overview'
import axios from 'axios'
import { getIdAndContentTypeFromTopics } from '../../utils'
import Icon from '@insided/deprecated-preact-components/assets'
import ButtonControl from '@insided/deprecated-preact-components/button-control'
import ListSelector from '@insided/deprecated-preact-components/list-selector/ListSelector'
import DropdownControl from '@insided/deprecated-preact-components/dropdown/DropdownControl'
import {
  Category,
  Group,
  ParentCategory,
  normalizeForDropdown
} from '@insided/deprecated-preact-components/category-selector/CategorySelector'
import MoveToModal from './MoveToModal'
import GroupedList from '@insided/deprecated-preact-components/list-selector/GroupedList'
import { getInsidedData } from '@insided/destination/utils/insidedDataStorage'

export const createMoveToComponent = (categories: Array<ParentCategory | Group>) => (props: BulkActionComponentProps) => (
  <MoveToComponent
    {...props}
    categories={categories}
  />
)

export interface MoveToComponentProps extends BulkActionComponentProps {
  categories: Array<ParentCategory | Group>
}

interface State {
  category: any | null
  isMoveToModalOpen: boolean
}

class MoveToComponent extends Component<MoveToComponentProps, State> {
  constructor() {
    super()
    this.state = {
      category: null,
      isMoveToModalOpen: false
    }
  }

  onCategorySelect = (category: Category) => {
    this.setState({ category, isMoveToModalOpen: true })
  }

  onMoveTo = () => {
    const { performBulkAction } = this.props
    const { category } = this.state

    const bulkAction = {
      successMessage: `Topic(s) moved to '${category.categoryName}'`,
      onClick: async (selectedTopics: any) =>
        await axios.post(
          `/community/api/bulk/process?moderatorId=${getInsidedData('user').userid}`,
          {
            action: 'move',
            topics: getIdAndContentTypeFromTopics(selectedTopics),
            params: {
              categoryId: category.categoryId
            }
          }
        )
    }

    performBulkAction(bulkAction)

    this.setState({ isMoveToModalOpen: false })
  }

  render() {
    const { numberOfSelectedItems, categories } = this.props
    const { category, isMoveToModalOpen } = this.state

    const items = normalizeForDropdown(categories).map((category) => {
      return {
        groupName: category.groupName,
        items:
          !category.categories || category.categories.length === 0
            ? []
            : category.categories?.map((childCategory) => ({
              title: childCategory.categoryName,
              value: childCategory.categoryId,
              onClick: () => this.onCategorySelect(childCategory)
            }))
      }
    })

    return (
      <div>
        <DropdownControl
          align='adjust'
          showDefaultChildren
          trigger={
            <ButtonControl
              title={
                <div>
                  <Icon icon='move' width={16} height={16} />
                  Move to
                </div>
              }
              size='medium'
              newStyle
              // eslint-disable-next-line @gorazdo/preact/prefer-classname
              class='qa-move-to'
            />
          }
          items={[]}
        >
          {() => {
            return (
              <ListSelector hasSearch placeholder='Search for category' items={items}>
                {(filteredItems: any[]) => <GroupedList items={filteredItems} />}
              </ListSelector>
            )
          }}
        </DropdownControl>
        <MoveToModal
          numberOfSelectedItems={numberOfSelectedItems}
          categoryName={category?.categoryName}
          isOpen={isMoveToModalOpen}
          onMoveTo={this.onMoveTo}
          onClose={() => this.setState({ isMoveToModalOpen: false })}
        />
      </div>
    )
  }
}

export default createMoveToComponent
